

/*eslint unicode-bom: ["error", "always"]*/
//Auto generated scripts from 'Beca.Content.Typescript' using 'Typewriter'




export enum FilterOperation {

    Contains = "Contains",
    Equals = "Equals",
    StartsWith = "Startswith",
    EndsWith = "Endswith",
    IsEmpty = "Isempty",
    IsNotEmpty = "Isnotempty",
    IsAnyOf = "Isanyof",

    // numerical
    Is = "Is",
    NumericEquals = "=",
    NumericNotEqual = "!=",
    Greater = ">",
    GreaterOrEqual = ">=",
    Lower = "<",
    LowerOrEqual = "<=",

    //dates
    After = "after",
    OnOrAfter = "onOrAfter",
    Before = "before",
    OnOrBefore = "onOrBefore",
    IsNot = "not",
}
